import React, { useState } from "react"
import "./CheckoutFooter.scss"
import { Button } from "../../atoms"
import {
  BOTH,
  SELF,
  OFFERED_PAY_BOTH,
  PAY_SELF,
  PAY_BOTH,
  PAYING_FOR,
} from "../../constants/messages"
import { withRouter } from "react-router"
import { connect } from "react-redux"
import _ from "../../utils/lodashUtils"
import Text from "antd/lib/typography/Text"
import {
  FirebaseService,
  FIREBASE_STATE_KEYS,
  FirebaseContext,
} from "../../firebase"
import { usePrevious } from "common-custom-hooks"
import BlockingModal from "../BlockingModal/BlockingModal"
import { TextTag } from "../../atoms/Typograpghy/index"
import {
  getGenderSpecificMessage,
  getPartnerNameorNickName,
} from "../../utils/helpers"

const CheckoutFooter = props => {
  const {
    user,
    partnerDetails,
    combinedPricesTotal,
    partner1Total = 0,
    partner2Total = 0,
  } = props
  const { dateState, partnerState, userState } = React.useContext(
    FirebaseContext
  )
  const partnerName = getPartnerNameorNickName(partnerState, "", partnerDetails)
  const isOrderCombined = _.get(
    dateState,
    FIREBASE_STATE_KEYS.IS_ORDER_COMBINED
  )
  const partnerPayStatus = _.get(
    dateState,
    `${FIREBASE_STATE_KEYS.PAY_STATUS}.${FIREBASE_STATE_KEYS.STATUS}`
  )
  const { payHandler, payStatus } = props
  let total = 0
  if (partner2Total && partner1Total) {
    total = (partner1Total + partner2Total).toFixed(2)
  } else if (partner2Total && !partner1Total) {
    total = partner2Total
  } else if (partner1Total && !partner2Total) {
    total = partner1Total
  }

  const previouspayStatus = usePrevious(payStatus)

  const [blockingModalVisibility, setblockingModalVisibility] = useState(false)

  const continueHandler = () => {
    //On click of pay decide what is the next state/screen for user
    if (isOrderCombined && partnerPayStatus === "COMBINED") {
      FirebaseService.write(
        "WAITING",
        `${FirebaseService.getDefaultPath()}${[
          FIREBASE_STATE_KEYS.PAY_STATUS,
        ]}/${[partnerState.userDetails.uuid]}/state/`
      )
      FirebaseService.setActiveRoute("/checkout/wait")
      props.history.push("/checkout/wait")
    } else if (payStatus) {
      FirebaseService.write(
        {
          ...payStatus,
          [userState.userDetails.uuid]: {
            state: "CONFIRM",
          },
        },
        `${FirebaseService.getDefaultPath()}${[FIREBASE_STATE_KEYS.PAY_STATUS]}`
      )
      FirebaseService.setActiveRoute("/checkout/detail")
      props.history.push("/checkout/detail")
    }
  }
  React.useEffect(() => {
    if (
      payStatus &&
      payStatus.status &&
      !_.isEqual(previouspayStatus, payStatus) &&
      payStatus.status === "BOTH"
    ) {
      setblockingModalVisibility(true)
    }
    if (partnerPayStatus === "COMBINED") {
      setblockingModalVisibility(true)
    }
  }, [payStatus, partnerPayStatus])

  const genderSelf =
    _.get(payStatus, "author.gender") === "MALE"
      ? "himself"
      : _.get(payStatus, "author.gender") === "FEMALE"
      ? "herself"
      : "themself"
  const partnerGender = getGenderSpecificMessage(
    _.get(partnerState, "userDetails.gender")
  )
  return (
    <div className="footer-wrapper">
      <div className="button-wrapper">
        <React.Fragment>
          {payStatus && payStatus.status === "SELF" && (
            <React.Fragment>
              <div className="centered-column">
                {payStatus.status && payStatus.status === "SELF" && (
                  <Text className="disclaimer-text">
                    {PAYING_FOR(partnerName, genderSelf)}
                  </Text>
                )}
                <div className="flex-adder">
                  {!isOrderCombined && (
                    <Button
                      btnType="primary"
                      btnSize="large"
                      onClick={() => payHandler(SELF)}
                    >
                      {user.username ===
                      _.get(partnerDetails, "partner1.username")
                        ? PAY_SELF(partner1Total)
                        : PAY_SELF(partner2Total)}
                    </Button>
                  )}
                  <Button
                    btnType="primary"
                    btnSize="large"
                    onClick={() => payHandler(BOTH)}
                    disabled
                  >
                    {PAY_BOTH(total)}
                  </Button>
                </div>
              </div>
            </React.Fragment>
          )}
          {((payStatus && payStatus.status === "BOTH") ||
            partnerPayStatus === "BOTH" ||
            partnerPayStatus === "COMBINED") && (
            <React.Fragment>
              {!isOrderCombined && (
                <Button
                  btnType="primary"
                  btnSize="large"
                  onClick={() => payHandler(SELF)}
                >
                  {user.username === partnerDetails.partner1.username
                    ? PAY_SELF(partner1Total)
                    : PAY_SELF(partner2Total)}
                </Button>
              )}
              <Button
                btnType="primary"
                btnSize="large"
                onClick={() => payHandler(BOTH)}
              >
                {PAY_BOTH(isOrderCombined ? combinedPricesTotal : total)}
              </Button>
              {/* Pop up to show partner has offered to pick up tab */}
              <BlockingModal
                blockingModalVisibility={blockingModalVisibility}
                continueHandler={continueHandler}
                title={OFFERED_PAY_BOTH(partnerName, partnerGender)}
              />
            </React.Fragment>
          )}
        </React.Fragment>
        {((!payStatus &&
          (!partnerPayStatus || partnerPayStatus === "CANCELLED")) ||
          (payStatus && payStatus.status === "CANCELLED")) && (
          <React.Fragment>
            {!isOrderCombined && (
              <Button
                btnType="primary"
                btnSize="large"
                onClick={() => payHandler(SELF)}
              >
                {_.get(user, "username", "") ===
                _.get(partnerDetails, "partner1.username")
                  ? PAY_SELF(partner1Total)
                  : PAY_SELF(partner2Total)}
              </Button>
            )}
            <Button
              btnType="primary"
              btnSize="large"
              type="primary"
              onClick={() => payHandler(BOTH)}
            >
              {PAY_BOTH(isOrderCombined ? combinedPricesTotal : total)}
            </Button>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}
const mapStateToProps = state => {
  return {
    user: _.get(state, "auth.user", {}),
    partnerDetails: _.get(state, "invitePeople.partnerDetails", {}),
    partnerName: _.get(state, "auth.partner.display_name", ""),
  }
}
export default connect(mapStateToProps, {})(withRouter(CheckoutFooter))
